const urogenital=
[
{symptom: "uti",
displayAs: "Current active UTI",
questionGroup: "duration",
},


{symptom: "recUti",
displayAs: "Hist of recurrent / frequent UTIs",
questionGroup: "freqAndDuration",
},


{symptom:"urinaryFrequency",
displayAs:"Urinary Frequency / Urgency",
questionGroup: "freqAndUrgency",
},

{symptom: "urinaryRetention",
displayAs: "Urinary hesitancy / retention / nocturia",
questionGroup: "hesRetNocturia",
},

{symptom:"haematuria",
displayAs:"Visible haematuria",
questionGroup: "haematuria",
},

{
symptom: "microHaematuria",
displayAs:"Microscopic haematuria",
questionGroup: "duration",
}





]

export default urogenital